import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './components/Dashboard.jsx';
import OrderForm from './components/OrderForm.jsx';
import Login from './components/Login.jsx';

function App() {
  const [currentView, setCurrentView] = useState('dashboard');
  const [customerEmail, setCustomerEmail] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [loggedInUser, setLoggedInUser] = useState('');

  // Check for existing authentication on app load
  useEffect(() => {
    const storedToken = localStorage.getItem('accessToken');
    const storedUser = localStorage.getItem('userEmail');
    
    if (storedToken && storedUser) {
      setAccessToken(storedToken);
      setLoggedInUser(storedUser);
      setIsAuthenticated(true);
    }
    
    // Check URL parameters for customer email
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');
    if (email) {
      setCustomerEmail(email);
      setCurrentView('orders');
    }
  }, []);

  const handleLoginSuccess = (token, email) => {
    setAccessToken(token);
    setLoggedInUser(email);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userEmail');
    setAccessToken('');
    setLoggedInUser('');
    setIsAuthenticated(false);
    setCurrentView('dashboard');
  };

  const renderView = () => {
    switch (currentView) {
      case 'dashboard':
        return <Dashboard />;
      case 'create-order':
        return <OrderForm onOrderCreated={() => setCurrentView('dashboard')} />;
      default:
        return <Dashboard />;
    }
  };

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="App">
      <header className="app-header">
        <div className="container">
          <h1>Zlatarenta Limit Orders</h1>
          <p>Advanced gold trading with automated limit orders</p>
          <div className="user-info">
            <span>Welcome, {loggedInUser}</span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>

      <nav className="app-nav">
        <div className="container">
          <div className="nav-buttons">
            <button
              className={`nav-btn ${currentView === 'dashboard' ? 'active' : ''}`}
              onClick={() => setCurrentView('dashboard')}
            >
              📊 Dashboard
            </button>
            <button
              className={`nav-btn ${currentView === 'create-order' ? 'active' : ''}`}
              onClick={() => setCurrentView('create-order')}
            >
              ➕ Create Order
            </button>
          </div>
        </div>
      </nav>

      <main className="app-main">
        <div className="container">
          {renderView()}
        </div>
      </main>

      <footer className="app-footer">
        <div className="container">
          <p>Zlatarenta - Premium Gold Trading</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
